import * as actions from './slice'

export const onboardingGetUser = {
  eventName: 'onboardingGetUser',
  initialiser: false,
  onSuccess: {
    action: actions.setOnboardingProfile,
    redux: true
  }
}
export const onboardingTrackEvent = {
  eventName: 'onboardingTrackEvent',
  initialiser: false,
  onStart: {
    action: actions.closePlaylistPopper,
    redux: true
  }
}
export const onboardingDismissMyLearning = {
  eventName: 'onboardingTrackEvent',
  initialiser: false,
  onStart: {
    action: actions.removeMyLearningBadge,
    redux: true
  }
}
export const onboardingDismissFeedback = {
  eventName: 'onboardingTrackEvent',
  initialiser: false,
  onStart: {
    action: actions.dismissMyLearningFeedback,
    redux: true
  }
}
